<template>
  <grid
    :cols="cols"
    :rows="rows"
    :auto-width="autoWidth"
    :pagination="pagination"
    :language="language"
  ></grid>
</template>


<script>
import Grid from "gridjs-vue";

export default {
  name: "Table",
  props: ["currentCategoryData", "quantitySelected"],
  components: { Grid },
  data() {
    return {
      // cols: [
      //   { id: "supplierName", name: "Назва" },
      //   // { id: "edrpou_code", name: "код ЄДРПОУ" },
      //   { id: "tot_value", name: "Сума підписаних контрактів" },
      //   { id: "perc_value", name: "% від вартості контрактів" },
      //   { id: "tot_contracts", name: "К-кість підписаних контрактів" },
      //   { id: "perc_contracts", name: "% від кількості контрактів" },
      //   { id: "amku", name: "Чи фігурує в Реєстрі АМКУ?" },
      // ],
      autoWidth: false,
      pagination: {
        enabled: false,
        limit: 5,
        summary: true,
      },
      language: {
        pagination: {
          previous: "Попередня",
          to: "-",
          of: "із",
          next: "Наступна",
          showing: "Показано",
          results: () => "результатів",
        },
        noRecordsFound: "Для цієї категорії дані недоступні :(",
      },
      basicColumns: ["suppliers_identifier.legalName", "amcu"],
      columnMapper: {
        "suppliers_identifier.legalName": "Назва",
        "suppliers_identifier.id": "код ЄДРПОУ",
        tot_value: "Сума підписаних контрактів",
        perc_value: "% від вартості контрактів",
        tot_contracts: "К-кість підписаних контрактів",
        perc_contracts: "% від кількості контрактів",
        amcu: "Чи фігурує в Реєстрі АМКУ?",
      },
      quantityMapper: {
        кількості: ["tot_contracts", "perc_contracts"],
        суми: ["tot_value", "perc_value"],
      },
    };
  },
  methods: {
    rowClick(event) {
      let idx = Array.prototype.indexOf.call(
        event.target.parentNode.parentNode.querySelectorAll("tr"),
        event.target.parentNode
      );

      let name = this.currentCategoryData[idx][
        "suppliers_identifier.legalName"
      ];
      let code = this.currentCategoryData[idx]["suppliers_identifier.id"];

      let url;

      if (name) {
        if (code.length === 8) {
          url = "https://ring.org.ua/edr/uk/company/" + code;
        } else {
          url = `https://ring.org.ua/search?q=${code}&datasources=procurement_winners`;
        }
      } else {
        url = `https://ring.org.ua/search?q=${code}&datasources=procurement_winners`;
      }

      window.open(url);
    },
  },
  computed: {
    rows() {
      return this.currentCategoryData.map((row) => {
        let new_row = {};

        Object.keys(row).forEach((key) => {
          if (this.allColumns.includes(key)) {
            if (key === "amcu") {
              new_row[key] = row[key] === "True" ? "Так" : "Ні";
            } else if (key === "suppliers_identifier.legalName") {
              new_row[key] = row[key]
                ? row[key]
                : "Код ЄДРПОУ / ІПН: " + row["suppliers_identifier.id"];
            } else {
              new_row[key] = row[key];
            }
          }
        });
        return new_row;
      });
    },
    quantityColumns() {
      return this.quantityMapper[this.quantitySelected];
    },
    allColumns() {
      return [this.basicColumns[0]]
        .concat(this.quantityColumns)
        .concat([this.basicColumns[1]]);
    },
    cols() {
      return this.allColumns.map((col) => ({
        id: col,
        name: this.columnMapper[col],
        attributes: (cell) => {
          return {
            "data-cell-content": cell,
            class: (function () {
              if (cell) {
                if (cell.slice(0, 3) === "Код") {
                  return "gridjs-td no-name";
                }
              }
            })(),
            onclick: (event) => this.rowClick(event),
          };
        },
      }));
    },
    // rows() {
    //   return this.currentCategoryData.map(function (row) {});
    // },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: e-UkraineLight;
  src: url(../assets/fonts/e-Ukraine-Light.woff);
}
th.gridjs-th {
  white-space: pre-wrap;
  // font-size: 14px;
}

.gridjs-wrapper:last-of-type {
  border-radius: 0;
  box-shadow: none;
  font-family: e-UkraineLight;
  max-height: 448px;
  // height: 448px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 11px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, 0.5);
  }
  .gridjs-table {
    font-size: 12px;
    border-radius: 0;
    table-layout: auto;
    th {
      background-color: #e5eef2;
    }
    thead.gridjs-thead {
      border-left: 1px solid #e5eef2;
      border-right: 1px solid #e5eef2;
    }
    tbody.gridjs-tbody {
      // max-height: 448px;
      overflow-y: auto;
      border-left: 1px solid #e5eef2;
      border-right: 1px solid #e5eef2;
      border-bottom: 1px solid #e5eef2;
      &::-webkit-scrollbar {
        -webkit-appearance: none;
      }
      &::-webkit-scrollbar:vertical {
        width: 11px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        border: 2px solid white; /* should match background, can't be transparent */
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    th.gridjs-th {
      background-color: #e5eef2;
      color: rgb(0, 0, 0);
      font-weight: normal;
      position: sticky;
      top: 0;
      z-index: 2;
    }
    tr.gridjs-tr {
      text-align: center;
      cursor: pointer;
      td.gridjs-td.no-name {
        position: relative;
      }
      td.gridjs-td.no-name:after {
        // content: url(../assets/images/ic_hint.png);
        content: "";
        background: url(../assets/images/ic_hint.png) no-repeat;
        background-size: 24px 24px;
        display: inline-block;
        // position: absolute;
        width: 24px;
        height: 24px;
        margin: -8px 8px;
        // cursor: pointer;
      }
      td.gridjs-td.no-name:hover:before {
        // content: url(../assets/images/ic_hint.png);
        content: "Для цього підрядника в даних відсутня назва. Клікніть, щоб знайти його на ring.org.ua";
        // background-size: 24px 24px;
        // display: inline-block;
        background-color: #e5eef1;
        position: absolute;
        width: 180px;
        // height: 24px;
        right: -128px;
        top: -88px;
        // left: 24px;
        // margin: 80x 0px;
        padding: 16px 24px;
        cursor: pointer;
        border-radius: 50px;
        z-index: 1;
      }
    }
  }
}
</style>